import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSyncProgress } from '../../../hooks';
import * as S from './styles';

const FULL_PROGRESS = 100;

const resolveMessage = ({ t, done, isSlow, messages, messageIndex }) => {
  if (done) {
    return {
      key: 'done',
      title: t('syncing.tracking.done.title'),
      text: t('syncing.tracking.done.text'),
    };
  }

  if (isSlow) {
    return {
      key: 'slow',
      title: t('syncing.tracking.slow.title'),
      text: t('syncing.tracking.slow.text'),
    };
  }

  const current = messages[messageIndex] || {};

  return {
    key: `message-${messageIndex}`,
    title: current.title,
    text: current.text,
  };
};

const SyncProgress = ({ done }) => {
  const [t] = useTranslation('calendar');

  const translatedMessages = t('syncing.tracking.messages', {
    returnObjects: true,
  });
  const messages = Array.isArray(translatedMessages) ? translatedMessages : [];

  const { messageIndex, percent, isSlow } = useSyncProgress({
    active: !done,
    messageCount: messages.length,
  });

  const message = resolveMessage({ t, done, isSlow, messages, messageIndex });

  return (
    <S.ProgressBox>
      <S.Message key={message.key} role="status" aria-live="polite">
        <S.MessageTitle>{message.title}</S.MessageTitle>
        <S.MessageText>{message.text}</S.MessageText>
      </S.Message>

      <S.Track
        role="progressbar"
        aria-label={t('syncing.tracking.progress-label')}
      >
        <S.Fill $percent={done ? FULL_PROGRESS : percent} />
      </S.Track>

      <S.Meta>
        <S.Dots aria-hidden="true">
          {messages.map((item, index) => (
            <S.Dot key={item.title} $active={done || index <= messageIndex} />
          ))}
        </S.Dots>
        <span>{t('syncing.tracking.average-time')}</span>
      </S.Meta>
    </S.ProgressBox>
  );
};

SyncProgress.propTypes = {
  done: propTypes.bool,
};

SyncProgress.defaultProps = {
  done: false,
};

export default SyncProgress;
